import React, { useState } from 'react';
import {
    IonButton, IonCol,
    IonInput,
    IonItem, IonRow,
    IonGrid, IonToggle, IonLabel, IonTextarea, IonIcon
} from '@ionic/react';
import {actionToCreateContributionOrder, actionToVerifyContributionOrderPayment} from "../apiHelpers/CommonAction";

import UserTransactionHistoryModal from "./UserTransactionHistoryModal";
import {star} from "ionicons/icons";
import useStore from "../zustand/useStore";
import {Capacitor} from "@capacitor/core";
import {openIosPaymentPage} from "../lib/paymentPageHelper";
let RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID;

export default function ContributeCard() {
    const {userAuthDetail:{userInfo}} = useStore();
    const [form, setForm] = useState({
        name: userInfo?.name,
        email: userInfo?.email,
        mobile: userInfo?.phone_number,
        pan: '',
        csr: '',
        cin: '',
        amount: '',
        address: '',
    });
    const [openTransactionModal, setOpenTransactionModal] = useState(false);

    const [errors, setErrors] = useState({});

    const handleChange = (field, value) => {
        setForm({ ...form, [field]: value });
        setErrors({ ...errors, [field]: '' }); // clear error on change
    };

    const validate = () => {
        let tempErrors = {};

        if (!form.name.trim()) tempErrors.name = 'Name is required';
        if (!form.email.trim()) {
            tempErrors.email = 'Email is required';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
            tempErrors.email = 'Invalid email format';
        }
        if (!form.mobile.trim()) {
            tempErrors.mobile = 'Mobile number is required';
        } else if (!/^\d{10}$/.test(form.mobile)) {
            tempErrors.mobile = 'Enter a valid 10-digit mobile number';
        }
        if (!form.pan.trim()) {
            tempErrors.pan = 'PAN is required';
        } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(form.pan)) {
            tempErrors.pan = 'Invalid PAN format';
        }
        if (!form.amount.trim() || parseFloat(form.amount) <= 0) {
            tempErrors.amount = 'Enter a valid amount';
        }
        if (form.csr === 'YES' && !form.cin.trim()) {
            tempErrors.cin = 'CIN is required for CSR contribution';
        }
        if (!form.address.trim()) tempErrors.address = 'Address is required';

        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };


    const handleDonate = async () => {
        if (!validate()) return;

        try {
            // Create order
            const { data } = await actionToCreateContributionOrder(form.amount,form);
            // Open Razorpay checkout

            if (Capacitor.getPlatform() === "ios") {
                await openIosPaymentPage(data.order.id,'contribution');
                return;
            }

            const options = {
                key: RAZORPAY_KEY_ID, // replace with your actual Razorpay key
                amount: data.order.amount,
                currency: "INR",
                name: "AICAS",
                description: "Contribution",
                order_id: data.order.id,
                prefill: {
                    name: form.name,
                    email: form.email,
                    contact: form.mobile
                },
                handler: async (response) => {
                    try {
                        await actionToVerifyContributionOrderPayment(form, response);
                        alert("Payment successful!");
                    } catch (error) {
                        console.error("Payment verification error:", error);
                        alert('Error verifying payment. Please contact support.');
                    }
                },
                theme: {
                    color: "#3399cc",
                },
            };

            const rzp = new window.Razorpay(options);
            rzp.open();

        } catch (err) {
            console.error(err);
        }
    };

    const openUserTransactionModal = () =>{
        setOpenTransactionModal(true)
    }

    return (
        <div className="contribute_page_card_section">
            <h1 className="m-0 p-heading text-left">Contribute & Support AICAS</h1>
            <p className="contribute-description text-left">
                AICAS has been working for almost 4 decades primarily focussing on taking up issues of CA members and CA students with policy makers. Every initiative requires investing adequate resources and here’s a chance for you to contribute. All Contributions to AICAS can either be done under Section 80G of Income Tax Act or Corporate Social Responsibility (CSR) donations under Companies Act.
            </p>
            <p className="contribute-description text-left">
                The contributions done by All India Chartered Accountants’ Society over last 4 decades have helped and contributed...
            </p>
            <p className="contribute-description text-left">
                Every contribution — big or small — fuels our mission to create a stronger, smarter, and more connected CA community. By donating, you’re investing in education, empowerment, and excellence within the world of finance.
            </p>
            <p className="contribute-description text-left">
                For any questions / concerns please contact <a href="mailto:support@caworld.org">support@caworld.org</a>
            </p>
            <IonGrid className="vision-section">
                <IonRow>
                    <IonCol size="12" sizeMd="6">
                        <div className="form-group rfp_submit_form_item">
                            <IonLabel>Name<IonIcon icon={star} className="required-star" /></IonLabel>
                            <IonInput
                                value={form.name}
                                className="rfp_form_input"
                                autocomplete={false}
                                onIonChange={e => handleChange('name', e.detail.value)}
                            />
                            {errors.name && <p className="error-text">{errors.name}</p>}
                        </div>
                    </IonCol>
                    <IonCol size="12" sizeMd="6">
                        <div className="form-group">
                            <IonLabel>Email ID<IonIcon icon={star} className="required-star" /></IonLabel>
                            <IonInput
                                value={form.email}
                                autocomplete={false}
                                className="rfp_form_input"
                                onIonChange={e => handleChange('email', e.detail.value)}
                            />
                            {errors.email && <p className="error-text">{errors.email}</p>}
                        </div>
                    </IonCol>
                </IonRow>

                <IonRow>
                    <IonCol size="12" sizeMd="6">
                        <div className="form-group">
                            <IonLabel>Mobile No<IonIcon icon={star} className="required-star" /></IonLabel>
                            <IonInput
                                type="tel"
                                autocomplete={false}
                                value={form.mobile}
                                onIonChange={e => handleChange('mobile', e.detail.value)}
                            />
                            {errors.mobile && <p className="error-text">{errors.mobile}</p>}
                        </div>
                    </IonCol>
                    <IonCol size="12" sizeMd="6">
                        <div className="form-group">
                            <IonLabel>PAN No<IonIcon icon={star} className="required-star" /></IonLabel>
                            <IonInput
                                value={form.pan}
                                autocomplete={false}
                                onIonChange={e => handleChange('pan', e.detail.value)}
                            />
                            {errors.pan && <p className="error-text">{errors.pan}</p>}
                        </div>
                    </IonCol>
                </IonRow>

                <IonRow>
                    <IonCol size="12" sizeMd="6">
                        <div className="form-group">
                            <IonLabel>Is this donation for a CSR Project?</IonLabel>
                            <IonItem lines="none">
                                <IonToggle
                                    autocomplete={false}
                                    checked={form.csr === 'YES'}
                                    onIonChange={e => handleChange('csr', e.detail.checked ? 'YES' : 'NO')}
                                    color="primary"
                                />
                            </IonItem>
                        </div>
                    </IonCol>
                    <IonCol size="12" sizeMd="6">
                        <div className="form-group">
                            <IonLabel>Amount (₹)<IonIcon icon={star} className="required-star" /></IonLabel>
                            <IonInput
                                type="number"
                                autocomplete={false}
                                value={form.amount}
                                onIonChange={e => handleChange('amount', e.detail.value)}
                            />
                            {errors.amount && <p className="error-text">{errors.amount}</p>}
                        </div>
                    </IonCol>

                    {form.csr === 'YES' && (
                        <IonCol size="12">
                            <div className="form-group">
                                <IonLabel>CIN No (Mandatory for CSR Contribution)</IonLabel>
                                <IonInput
                                    value={form.cin}
                                    autocomplete={false}
                                    onIonChange={e => handleChange('cin', e.detail.value)}
                                />
                                {errors.cin && <p className="error-text">{errors.cin}</p>}
                            </div>
                        </IonCol>
                    )}
                </IonRow>

                <IonRow>
                    <IonCol size="12">
                        <div className="form-group address-texarea">
                            <IonLabel>Address<IonIcon icon={star} className="required-star" /></IonLabel>
                            <IonTextarea
                                value={form.address}
                                rows="3"
                                autocomplete={false}
                                onIonChange={e => handleChange('address', e.detail.value)}
                            />
                            {errors.address && <p className="error-text">{errors.address}</p>}
                        </div>
                    </IonCol>
                </IonRow>

                <IonRow>
                    <IonCol>
                        <IonButton expand="block" className="join-now-button m-0" onClick={handleDonate}>
                            Click to Contribute
                        </IonButton>
                    </IonCol>
                    <IonCol>
                        <IonButton expand="block" className="join-now-button m-0" onClick={openUserTransactionModal}>Transactions</IonButton>
                    </IonCol>
                </IonRow>
            </IonGrid>
            {(openTransactionModal) &&
            <UserTransactionHistoryModal
                isOpen={openTransactionModal}
                onDidDismiss={() => {
                    setOpenTransactionModal(false)
                }}
            />
            }
        </div>
    );
}
